import styled from "styled-components";

export const EVoucherAddToCusFormStyled = styled.div`
  position: relative;
  border-radius: 0.75rem;
  padding: 2.5rem 1rem 2rem 1rem;
  width: 100%;
  max-width: 400px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .btn_close_wrap {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .input_wrap {
    margin-bottom: 1.25rem;
  }
`;
